/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import IntroSection from './components/introSection';
import ContactInfo from './components/contactInfo';
import DeleteMobileAppInfo from './components/deleteMobileAppInfo';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      useReCaptcha={false}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Delete online account',
          linkUrl: '/help/delete/account/',
          linkAriaLabel: 'Northwestern Mutual App Download',
        },
      ]}>

      <IntroSection />

      <ContactInfo />

      <DeleteMobileAppInfo />

    </Page>
  );
};
